module.exports = __webpack_public_path__ + "static/media/logo-white.2c0bd1d8.png";